module.exports = __webpack_public_path__ + "static/img/40-北京第七中学1.a3d6920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/40-北京第七中学1.png
// module id = RIfw
// module chunks = 0